import { useState, useRef } from "react";
import "./experience.css";
import Fade from "react-reveal/Fade";
import { RxDot } from "react-icons/rx";

const Experience = () => {
  const [exp, setExp] = useState("Itex");
  const [switchBorder, setSwitchBorder] = useState("movingBorder borderOne");
  const tabRefs = {
    Itex: useRef(null),
    Velto: useRef(null),
    Adroitsoft: useRef(null),
    Qevolt: useRef(null),
    Prunedge: useRef(null),
  };

  const scrollToTab = (tabName) => {
    const tabElement = tabRefs[tabName]?.current;
    if (tabElement) {
      tabElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };

  const itex = () => {
    setExp("Itex");
    setSwitchBorder("movingBorder borderOne");
    scrollToTab("Itex");
  };
  const velto = () => {
    setExp("Velto");
    setSwitchBorder("movingBorder borderTwo");
    scrollToTab("Velto");
  };
  const adroitsoft = () => {
    setExp("Adroitsoft");
    setSwitchBorder("movingBorder borderThree");
    scrollToTab("Adroitsoft");
  };
  const qevolt = () => {
    setExp("Qevolt");
    setSwitchBorder("movingBorder borderFour");
    scrollToTab("Qevolt");
  };
  const prunedge = () => {
    setExp("Prunedge");
    setSwitchBorder("movingBorder borderFive");
    scrollToTab("Prunedge");
  };

  return (
    <div className="experience-container" id="experience">
      <Fade delay={100}>
        <div className="section-header-text">
          <span className="section-header-num">02.</span>
          Employment History
        </div>
      </Fade>

      <div className="experience-section-content">
        <Fade delay={200}>
          <div className="work-switch">
            <ul>
              <div className={switchBorder}></div>
              <li
                ref={tabRefs.Itex}
                onClick={itex}
                style={{ color: exp === "Itex" ? "var(--accent-color)" : "" }}
              >
                ITEX
              </li>
              <li
                ref={tabRefs.Velto}
                onClick={velto}
                style={{ color: exp === "Velto" ? "var(--accent-color)" : "" }}
              >
                Velto Studio
              </li>
              <li
                ref={tabRefs.Adroitsoft}
                onClick={adroitsoft}
                style={{ color: exp === "Adroitsoft" ? "var(--accent-color)" : "" }}
              >
                Adroitsoft
              </li>
              <li
                ref={tabRefs.Qevolt}
                onClick={qevolt}
                style={{ color: exp === "Qevolt" ? "var(--accent-color)" : "" }}
              >
                Qevolt Limited
              </li>
              <li
                ref={tabRefs.Prunedge}
                onClick={prunedge}
                style={{ color: exp === "Prunedge" ? "var(--accent-color)" : "" }}
              >
                Prunedge
              </li>
            </ul>
          </div>
        </Fade>
        <Fade delay={300}>
          <div className="work-content">
            {exp === "Itex" && (
              <Fade duration={400}>
                <div className="exp-content">
                  <div className="exp-header">
                    Fullstack Developer (Focused on Frontend Architecture){" "}
                    <span className="accent">@ITEX Integrated Services</span>
                  </div>
                  <div className="exp-date">November 2024 - Present</div>
                  <ul className="exp-bullets">
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Performance Optimization:</strong> Resolved a critical bottleneck within the payment gateway, optimizing the rendering cycle to cut application delays by 5+ seconds for over 10,000 business clients.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Feature Ownership:</strong> Took full ownership of the Kitchens & Accessories E-commerce platform, translating UI/UX designs into pixel-perfect React components while integrating the Redstar ClicknShip API for logistics.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Architecture & Scalability:</strong> Built dynamic, type-safe web applications using React and TypeScript, ensuring cross-browser compatibility and adherence to accessibility standards.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Team Collaboration:</strong> Collaborated closely with product managers and backend engineers to define API schemas, ensuring efficient data fetching and reducing payload sizes.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Code Quality:</strong> Established stricter code review guidelines and documentation practices to improve maintainability and onboard new developers faster.
                    </li>
                  </ul>
                </div>
              </Fade>
            )}
            {exp === "Velto" && (
              <Fade duration={400}>
                <div className="exp-content">
                  <div className="exp-header">
                    Frontend Engineer (Contract){" "}
                    <span className="accent">@Velto Studio</span>
                  </div>
                  <div className="exp-date">September 2024 - March 2025</div>
                  <ul className="exp-bullets">
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Design Systems:</strong> Developed a scalable UI component library using React, Tailwind CSS, and Storybook, significantly reducing development time for future features.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>State Management:</strong> Implemented complex state logic for the <strong>Tradeport</strong> web app using Zustand and React Query, ensuring data consistency across the application.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>SSR/SSG Implementation:</strong> Leveraged Next.js to build the <strong>Tradeport</strong> platform, utilizing Server-Side Rendering (SSR) for critical dashboards to enhance SEO and load performance.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Mobile Development:</strong> Built the <strong>Blinq</strong> mobile application frontend using React Native and NativeWind, ensuring a seamless experience across iOS and Android devices.
                    </li>
                  </ul>
                </div>
              </Fade>
            )}
            {exp === "Adroitsoft" && (
              <Fade duration={400}>
                <div className="exp-content">
                  <div className="exp-header">
                    Frontend Web Development Instructor{" "}
                    <span className="accent">@Adroitsoft Nigeria Limited</span>
                  </div>
                  <div className="exp-date">February 2024 - January 2025</div>
                  <ul className="exp-bullets">
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      Mentored students on modern frontend practices, emphasizing the importance of semantic HTML, CSS3, and JavaScript (ES6+).
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      Taught responsive design principles and "Mobile First" methodologies to ensure applications perform well on all device sizes.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>E-commerce Backend Project:</strong> Designed the backend architecture using C# and .NET, giving me a deep understanding of RESTful API structures—knowledge I leverage to communicate effectively with backend teams in frontend roles.
                    </li>
                  </ul>
                </div>
              </Fade>
            )}
            {exp === "Qevolt" && (
              <Fade duration={400}>
                <div className="exp-content">
                  <div className="exp-header">
                    Frontend Web / Mobile Developer{" "}
                    <span className="accent">@Qevolt Limited</span>
                  </div>
                  <div className="exp-date">July 2022 - January 2024</div>
                  <ul className="exp-bullets">
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>End-to-End Delivery:</strong> Led the frontend development of the flagship Qevolt mobile app (React Native) and web platform (Next.js), managing the lifecycle from design handoff to production deployment.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Testing & Quality:</strong> Implemented unit tests and engaged in rigorous bug tracking to ensure product stability, delivering hotfixes rapidly based on user feedback.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      <strong>Automation:</strong> Automated internal team workflows using Node.js scripts and Zapier, demonstrating a proactive problem-solving mindset beyond standard frontend tasks.
                    </li>
                  </ul>
                </div>
              </Fade>
            )}
            {exp === "Prunedge" && (
              <Fade duration={400}>
                <div className="exp-content">
                  <div className="exp-header">
                    Frontend Web Developer (Contract){" "}
                    <span className="accent">@Prunedge</span>
                  </div>
                  <div className="exp-date">February 2023 - August 2023</div>
                  <ul className="exp-bullets">
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      Utilized React.js, TypeScript, and Chakra UI to build responsive web applications, ensuring adherence to design specifications and brand guidelines.
                    </li>
                    <li className="exp-bullet">
                      <RxDot className="expIcon" />
                      Integrated complex RESTful APIs to manage user data efficiently, optimizing frontend performance metrics.
                    </li>
                  </ul>
                </div>
              </Fade>
            )}
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Experience;
